/* @flow */
import React from 'react';
import Translate from 'react-translate-component';
import Bullhorn from '../svg/bullhorn.js';
import FeatureFlagsService from 'frilans-finans/feature-flags/feature-flags-service';
import { authenticationService } from 'interactive-solutions/authentication';
import * as variables from 'frilans-finans/variables';

export class BetaBanner extends React.Component {

  constructor () {
    super();

    this.state = {
      showBetaBanner: false
    };

    this.openBeta = this.openBeta.bind(this);
  }

  componentDidMount () {
    try {
      // check if active
      FeatureFlagsService.getStoryblokFeatureFlags()
        .then((features) => {
          const betaBannerFeature = features.find(feature => feature.name === 'account-web-try-beta-banner');

          if (betaBannerFeature && +betaBannerFeature.value === 1) {
            this.setState({
              showBetaBanner: true
            });
          }
        });
    } catch (_) {}
  }

  getBetaUrl () {
    if (variables.appEnv === 'staging') {
      return 'https://flutter-web.staging.ffdev.se';
    }
    if (variables.appEnv === 'demo' || variables.appEnv === 'testdrive') {
      return 'https://flutter-web.sandbox.ffdev.se';
    }

    return 'https://konto-beta.frilansfinans.se';
  }

  openBeta () {
    const token = authenticationService.oauthToken.accessToken
      ? authenticationService.oauthToken.accessToken
      : '';
    const betaDomain = this.getBetaUrl();
    window.open(betaDomain + '/token-login?access_token=' + token, '_ff_beta');
  }

  render () {
    return !this.state.showBetaBanner
      ? null
      : (<div className='beta-banner-wrapper'>
        <div className='beta-banner-icon-container'>
          <div className='beta-banner-icon'>
            <Bullhorn
              width='20'
              height='20'
            />
          </div>
        </div>
        <div className='beta-banner-text'>
          <div className='beta-banner-inner-text'>
            <Translate className='beta-banner-text-title' content='BETA_BANNER_TEXT_TITLE' />
            <Translate className='beta-banner-text-subtitle' content='BETA_BANNER_TEXT_SUBTITLE' />
          </div>
        </div>
        <div className='beta-banner-button'>
          <div
            className='btn'
            onClick={this.openBeta}
            id="button-open-beta"
          >
            <Translate content='BETA_BANNER_BUTTON' />
          </div>
        </div>
      </div>);
  }
}

export default BetaBanner;



/** WEBPACK FOOTER **
 ** ./src/components/beta-banner/beta-banner.js
 **/